import {
  RecruitmentPost,
  SocialPost,
  StreamContentPydanticModel,
} from "@virtualprogaming/js-public-sdk";

export interface SearchRequest {
  query?: string;
  limit: number;
  offset: number;
}

export enum GroupStageView {
  Groups = "groups",
  Matches = "matches",
}

export enum LeaderboardPeriod {
  Weekly = "weekly",
  All = "all",
}

export enum StreamType {
  LiveStreams = "live streams",
  UpcomingStreams = "upcoming streams",
}

export enum CompetitionTypes {
  Tournaments = "tournaments",
  Communities = "communities",
}

export enum LineUpType {
  HomeLineUp = "home line up",
  AwayLineUp = "away line up",
}

export enum StreamsTypes {
  Streams = "streams",
  LiveStreams = "live",
}

export interface ChannelStreamProps {
  stream: StreamContentPydanticModel;
  channelName: string;
  channelViews: string | number;
}

export {};

export interface UserPostCommentData {
  family_name: string;
  given_name: string;
  image: string;
  is_staff: boolean;
  is_superuser: boolean;
  username: string;
  id: number;
}
export interface TeamPostCommentData {
  id: number;
  logo: string;
  name: string;
  slug: string;
}

export interface CommentData {
  id: number;
  user_id: number;
  team_id: number;
  post_id: number;
  comment: string;
  created_at: string;
}

export interface PostCommentData {
  comment: CommentData;
  user?: UserPostCommentData;
  team?: TeamPostCommentData;
}
export interface RecentPostCommentData {
  post: SocialPost;
  user?: UserPostCommentData;
  team?: TeamPostCommentData;
}
export interface RecentPostsData {
  [key: number]: RecentPostCommentData;
}

export interface RecentPlayerFollowsData {
  player: UserPostCommentData;
  followed_player: UserPostCommentData;
  at: string;
}

export interface RecentPlayerLikesData {
  player: UserPostCommentData;
  liked_post: SocialPost;
  at: string;
}
export interface RecentTeamFollowsData {
  player: UserPostCommentData;
  followed_team: TeamPostCommentData;
  at: string;
}

export interface RecruitmentRecentPlayerLikesData {
  player: UserPostCommentData;
  liked_post: RecruitmentPost;
  at: string;
}

export enum NotificationsModes {
  Notifications = "notifications",
  GlobalNotifications = "global-notifications",
  Create = "create",
  Settings = "settings",
}
